export function getEntryWithQuestionKey(questionnaireForm, questionKey) {
    if (!questionnaireForm) {
        return null;
    }

    const entries = questionnaireForm.entries;

    for (let i=0; i<entries.length; i++) {
        if (entries[i].question.key === questionKey) {
            return entries[i];
        }
    }

    return null;
}
